export default function WeightInput({ setWeight }) {
  const handleWeightChange = (e) => {
    const val = e.target.value
    setWeight(val / 2.205)
  }

  return (
    <div className="input-group mb-3">
      <span className="input-group-text" >Weight (lb)</span>
      <input type="number" min={0} className="form-control" placeholder={230} onChange={handleWeightChange} />
    </div>
  )
}
